export type XCNotification =
  | {
      type: "matches";
      count: number;
      receiverIdentifier: string;
    }
  | {
      type: "connected";
      partnerName: string;
      receiverIdentifier: string;
    }
  | {
      type: "request";
      partnerName: string;
      receiverIdentifier: string;
    }
  | {
      type: "acceptedRequest";
      partnerName: string;
      receiverIdentifier: string;
    }
  | {
      type: "superlike";
      receiverIdentifier: string;
    }
  | {
      type: "newBatchOfCards";
    };

export interface FirebaseNotificationValue {
  title: string;
  body: string;
  receiverIdentifier: string;
  /** Lets the backend type the push's deep link for open attribution. */
  type: string;
}

export class XCNotificationHelper {
  public static matches(
    count: number,
    receiverIdentifier: string,
  ): XCNotification {
    return {
      type: "matches",
      count,
      receiverIdentifier,
    };
  }

  public static connected(
    partnerName: string,
    receiverIdentifier: string,
  ): XCNotification {
    return {
      type: "connected",
      partnerName,
      receiverIdentifier,
    };
  }

  public static request(
    partnerName: string,
    receiverIdentifier: string,
  ): XCNotification {
    return {
      type: "request",
      partnerName,
      receiverIdentifier,
    };
  }

  public static acceptedRequest(
    partnerName: string,
    receiverIdentifier: string,
  ): XCNotification {
    return {
      type: "acceptedRequest",
      partnerName,
      receiverIdentifier,
    };
  }

  public static newBatchOfCards(): XCNotification {
    return {
      type: "newBatchOfCards",
    };
  }

  public static superlike(receiverIdentifier: string): XCNotification {
    return {
      type: "superlike",
      receiverIdentifier,
    };
  }

  public static title(notification: XCNotification): string {
    switch (notification.type) {
      case "matches":
        return "You have a new match! 🔥";
      case "connected":
        return "Your partner has connected with you! ❤️";
      case "newBatchOfCards":
        return "New cards available! 🎉";
      case "request":
        return `${notification.partnerName} wants to play with you! 😏`;
      case "acceptedRequest":
        return `${notification.partnerName} accepted your request! 🏆`;
      case "superlike":
        return "Your partner got excited about a card 😏";
      default:
        return "";
    }
  }

  public static body(notification: XCNotification): string {
    switch (notification.type) {
      case "matches":
        return "Check it out now.";
      case "connected":
        return `You are now connected to ${notification.partnerName}`;
      case "newBatchOfCards":
        return "Go have some fun!";
      case "request":
        return "Accept their request to start playing together.";
      case "acceptedRequest":
        return "Start playing with them now.";
      case "superlike":
        return "This special card is waiting at the top of your deck.";
      default:
        return "";
    }
  }

  public static firebaseValue(
    notification: XCNotification,
  ): FirebaseNotificationValue | Record<string, never> {
    if (notification.type === "newBatchOfCards") {
      return {};
    }

    return {
      title: XCNotificationHelper.title(notification),
      body: XCNotificationHelper.body(notification),
      receiverIdentifier: notification.receiverIdentifier,
      type: notification.type,
    };
  }
}
